import React, {Component} from 'react';
import $ from "jquery";
import moment from "moment";
import { CURRENCY } from '../libs/utils/Const';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};
class CheckListModal extends Component {
    

    closeModal = () => {
        $('#checkListModal').modal('hide');
    }

    changeDocDate = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].DueDate = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    changeTotalCheck = (event, index) => {
        const {model, refreshTotal} = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                model.CheckList[index].CheckSum = event.nativeEvent.target.value;
            }
        }
        refreshTotal(model);
    };

    changeContry = (event, index) => {
        const { model, refreshTotal, isAccountPayment = false } = this.props;
        model.CheckList[index].CountryCod = event.nativeEvent.target.value;
        if (isAccountPayment) {
            model.CheckList[index].BankCode = '--';
        }
        refreshTotal(model);
    };

    changeBank = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].BankCode = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    validateTotalCheckNull = (index) => {
        const {model, refreshTotal} = this.props;

        let value = model.CheckList[index].CheckSum;

        if (value.length == 0) {
            model.CheckList[index].CheckSum = 0;
        }

        let newModel = this.sumCheck(model);
        refreshTotal(newModel);
    };

    sumCheck = model => {
        let suma = 0;
        let checks = model.CheckList || [];

        checks.map(check => {
            suma += parseFloat(check.CheckSum);
        })

        model.CheckSum = suma;
        return model;

    }

    changeBranch = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].Branch = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    changeAcctNum = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].AcctNum = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    changeTrnsfrable = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].Trnsfrable = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    changeCheckAccount = (event, index) => {
        const {model, refreshTotal} = this.props;
        model.CheckList[index].CheckAccount = event.nativeEvent.target.value;
        refreshTotal(model);
    };

    render() {
        const { model, addNewItem, deleteItem, dataInfo, action, isAccountPayment = false } = this.props;

        let cheques = model.CheckList || [];
        let contries = dataInfo.contries || [];
        let banks = dataInfo.banks || [];
        return (
            <div
                className="modal fade bd-example-modal-xl bgtransparent modal-open scroll" id="checkListModal"
                role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                             style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Lista de Cheques
                            </h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" style={{height: 660, maxHeight: 660}}>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                <div
                                                    className="w-100 table-scroll tab-pane fade show active "
                                                    id="dataContenido"
                                                    role="tabCon"
                                                    aria-labelledby="nav-home-tab-Contenido"
                                                    style={{maxHeight: 490}}>
                                                    <table
                                                        id="dataTableDocuments"
                                                        className="display"
                                                        style={{width: '100%', marginBottom: 40, marginRight: -2000}}>
                                                        <thead className="table-header-yellow">
                                                        <tr>
                                                            <td className="sticky-header1"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Fecha
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center",
                                                                    width: 700
                                                                }}>
                                                                Importe
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center",
                                                                    maxWidth: 900
                                                                }}>
                                                                País
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Nombre del Banco
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Sucursal
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Cuenta
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Número de Cheque
                                                            </td>
                                                            <td className="sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                                Endoso
                                                            </td>

                                                            <td className="sticky-columns sticky-header"
                                                                style={{
                                                                    backgroundColor: '#d2ab24',
                                                                    textAlign: "center"
                                                                }}>
                                                            </td>
                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        {cheques.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td className="">
                                                                        <input
                                                                            id="txtPostingDate"
                                                                            style={{
                                                                                width: 180,
                                                                                important: true,
                                                                                backgroundColor: 'transparent',
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                            }}
                                                                            className="form-control  btn-outline-secondary"
                                                                            type={action == 2 ? 'date' : 'date'}
                                                                            disabled={action == 2 ? true : false}
                                                                            placeholder="Fecha min"
                                                                            autoComplete="off"
                                                                            value={item.DueDate}
                                                                            onChange={(event) => this.changeDocDate(event, index)}
                                                                        /></td>
                                                                    <td style={{
                                                                        width: '100%',
                                                                        paddingLeft: 2,
                                                                        paddingRight: 2
                                                                    }}><input type=" text"
                                                                              disabled={action == 2 ? true : false}
                                                                              className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                              style={{
                                                                                  backgroundColor: 'transparent',
                                                                                  textAlign: "right",
                                                                                  borderColor: '#ced4da',
                                                                                  color: '#000',
                                                                                  width: '100%'
                                                                              }}
                                                                              value={item.CheckSum}
                                                                              onChange={(event) => this.changeTotalCheck(event, index)}
                                                                              onBlur={event => this.validateTotalCheckNull(index)}
                                                                    />
                                                                    </td>
                                                                    <td>
                                                                        <select
                                                                            disabled={action == 2 ? true : false}
                                                                            className="form-control col btn-outline-secondary select"
                                                                            value={item.CountryCod}
                                                                            onChange={(event) => this.changeContry(event, index)}
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                textAlign: "right",
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingLeft: 2,
                                                                                paddingRight: 2,
                                                                                width: 190
                                                                            }}
                                                                        >
                                                                            <option value="--">--</option>
                                                                            {contries.map((contry, index) => {
                                                                                return (
                                                                                    <option value={contry.Code}
                                                                                            key={contry.Code}>{contry.Name}</option>
                                                                                )

                                                                            })}
                                                                        </select>
                                                                    </td>
                                                                    <td><select
                                                                        disabled={action == 2 ? true : false}
                                                                        className="form-control col btn-outline-secondary select"
                                                                        value={item.BankCode}
                                                                        onChange={(event) => (isAccountPayment ? item.CountryCod : true) && this.changeBank(event, index)}
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            textAlign: "right",
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                            paddingLeft: 2,
                                                                            paddingRight: 2,
                                                                            width: '100%'
                                                                        }}
                                                                    >
                                                                        <option value="--">--</option>
                                                                        {banks?.filter(bank => { return isAccountPayment ? bank.CountryCod === item.CountryCod : true; })?.map((bank, index) => {
                                                                            return (
                                                                                <option value={bank.BankCode}
                                                                                    key={bank.BankCode}>{bank.BankName}</option>
                                                                            )

                                                                        })}
                                                                    </select>
                                                                    </td>
                                                                    <td><input type=" text"
                                                                               disabled={action == 2 ? true : false}
                                                                               className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                               style={{
                                                                                   backgroundColor: 'transparent',
                                                                                   textAlign: "right",
                                                                                   borderColor: '#ced4da',
                                                                                   color: '#000',
                                                                                   maxWidth: 900
                                                                               }}
                                                                               value={item.Branch}
                                                                               maxLength={50}
                                                                               onChange={(event) => this.changeBranch(event, index)}
                                                                    />
                                                                    </td>
                                                                    <td><input type=" text"
                                                                               disabled={action == 2 ? true : false}
                                                                               className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                               style={{
                                                                                   backgroundColor: 'transparent',
                                                                                   textAlign: "right",
                                                                                   borderColor: '#ced4da',
                                                                                   color: '#000',
                                                                                   maxWidth: 900,
                                                                               }}
                                                                               value={item.AcctNum}
                                                                               maxLength={50}
                                                                               onChange={(event) => this.changeAcctNum(event, index)}
                                                                    />
                                                                    </td>
                                                                    <td style={{textAlign: "center"}}>
                                                                        <input type=" text"
                                                                               disabled={action == 2 ? true : false}
                                                                               className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                               style={{
                                                                                   backgroundColor: 'transparent',
                                                                                   textAlign: "right",
                                                                                   borderColor: '#ced4da',
                                                                                   color: '#000',
                                                                                   maxWidth: 900,
                                                                               }}
                                                                               maxLength={15}
                                                                               value={item.CheckAccount}
                                                                               onChange={(event) => this.changeCheckAccount(event, index)}
                                                                        /></td>
                                                                    <td>
                                                                        <select
                                                                            disabled={action == 2 ? true : false}
                                                                            className="form-control col btn-outline-secondary select"
                                                                            value={item.Trnsfrable}
                                                                            onChange={(event) => this.changeTrnsfrable(event, index)}
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                textAlign: "right",
                                                                                borderColor: '#ced4da',
                                                                                color: '#000',
                                                                                paddingLeft: 2,
                                                                                paddingRight: 2,
                                                                                width: '100%'
                                                                            }}
                                                                        >
                                                                            <option value="N">No</option>
                                                                            <option value="Y">Sí</option>
                                                                        </select>
                                                                    </td>
                                                                    <td
                                                                        className="sticky-columns"
                                                                        style={{
                                                                            backgroundColor: '#FFF',
                                                                            textAlign: 'center'
                                                                        }}>
                                                                        {/*Eliminar*/}
                                                                        {action == 1 && <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                padding: 5, textAlign: "center",
                                                                                color: '#c42222',
                                                                            }}
                                                                            className="btn"
                                                                            onClick={() => deleteItem(index)}>
                                                                            <i className="fas fa-trash-alt"
                                                                               aria-hidden="true" size="10"/>
                                                                        </button>}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}

                                                        <tr>
                                                            <td
                                                                className=" "
                                                                style={{backgroundColor: '#FFF', textAlign: 'center'}}>
                                                                {action == 1 && <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        padding: 5,
                                                                        color: 'green',
                                                                    }}
                                                                    className="btn"
                                                                    onClick={addNewItem}>
                                                                    <i className="fa fa-plus-circle"
                                                                       aria-hidden="true" size="10"/>
                                                                </button>}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </table>
                                        </div>
                                        <br></br>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Total de los cheques</span>
                                                    </div>
                                                        <input style={{textAlign: 'right'}} type="text" className="form-control" disabled="true" value={CURRENCY + formatNumber.new(model.CheckSum)}/>
                                                    
                                                </div>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Total de Documento</span>
                                                    </div>
                                                        <input style={{textAlign: 'right'}} type="text" className="form-control" disabled="true" value={CURRENCY + formatNumber.new(model.totalDocumento)}/>
                                                    
                                                </div>
                                                {action == 1 &&  
                                                <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Restante</span>
                                                </div>
                                                        <input style={{textAlign: 'right'}} type="text" className="form-control" disabled="true" value={CURRENCY + ' ' + formatNumber.new(model.totalRestante)}/>
                                                    
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CheckListModal;
